module.exports = __webpack_public_path__ + "static/media/background-jason-blackeye-unsplash.4577b225.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background-jason-blackeye-unsplash.jpg
// module id = 1743
// module chunks = 0